var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('div',{staticClass:"close",on:{"click":_vm.onClose}}),_c('img',{attrs:{"src":require("../../assets/img/panel/PortOperatingIncome.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }